import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, mergeProps as _mergeProps, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, renderList as _renderList, vShow as _vShow, withDirectives as _withDirectives, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = {
  style: {"width":"400px"},
  class: "d-flex justify-center"
}
const _hoisted_2 = {
  style: {"width":"400px"},
  class: "d-flex justify-center"
}
const _hoisted_3 = { style: {"height":"calc(100vh - 157px)","overflow-y":"auto","border-top-left-radius":"25px","border-top-right-radius":"25px"} }
const _hoisted_4 = {
  key: 0,
  class: "pl-4"
}
const _hoisted_5 = {
  key: 0,
  class: "pl-4 pt-2"
}
const _hoisted_6 = {
  key: 0,
  class: "pl-4 pt-2"
}
const _hoisted_7 = {
  key: 1,
  class: "pl-4 pt-2"
}
const _hoisted_8 = {
  key: 0,
  class: "pl-4 pt-2",
  style: {"color":"#e9273c"}
}
const _hoisted_9 = {
  key: 1,
  class: "pl-4 pt-2"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_btn_back = _resolveComponent("v-btn-back")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_tooltip = _resolveComponent("v-tooltip")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn_prev = _resolveComponent("v-btn-prev")!
  const _component_v_btn_next = _resolveComponent("v-btn-next")!
  const _component_v_btn_icon = _resolveComponent("v-btn-icon")!
  const _component_v_list_item_title = _resolveComponent("v-list-item-title")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_list = _resolveComponent("v-list")!
  const _component_v_menu = _resolveComponent("v-menu")!
  const _component_v_progress_circular = _resolveComponent("v-progress-circular")!
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_oss_text_field_filled = _resolveComponent("oss-text-field-filled")!
  const _component_AccountableAccountBalanceDetail = _resolveComponent("AccountableAccountBalanceDetail")!
  const _component_v_textarea = _resolveComponent("v-textarea")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_AuditConnectedAcrDocuments = _resolveComponent("AuditConnectedAcrDocuments")!
  const _component_AuditConnectedAcrResults = _resolveComponent("AuditConnectedAcrResults")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_UsersActivitiesHistory = _resolveComponent("UsersActivitiesHistory")!
  const _component_oss_dialog = _resolveComponent("oss-dialog")!
  const _component_AuditDeleteAuditCheckResultDialog = _resolveComponent("AuditDeleteAuditCheckResultDialog")!
  const _component_AccountingItemEdition2 = _resolveComponent("AccountingItemEdition2")!
  const _component_Chat = _resolveComponent("Chat")!
  const _component_AuditCheckDocumentsManager = _resolveComponent("AuditCheckDocumentsManager")!
  const _component_v_container = _resolveComponent("v-container")!

  return (_openBlock(), _createBlock(_component_v_container, {
    "grid-list-md": "",
    fluid: ""
  }, {
    default: _withCtx(() => [
      _createVNode(_component_v_row, { class: "d-flex justify-space-between mb-1" }, {
        default: _withCtx(() => [
          _createVNode(_component_v_col, {
            cols: "6",
            class: "d-flex flex-column"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_row, { "no-gutters": "" }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_col, {
                    cols: "1",
                    class: "d-flex align-center justify-center"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_btn_back, {
                        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.push({ name: 'auditReport' })))
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_col, { cols: "11" }, {
                    default: _withCtx(() => [
                      _createElementVNode("h2", null, _toDisplayString(_ctx.$t("audit." + _ctx.acKey + ".title")), 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_v_row, { "no-gutters": "" }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_col, { cols: "1" }),
                  _createVNode(_component_v_col, { cols: "10" }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(`Statut : ${_ctx.checkStatus}`), 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_v_col, { cols: "6" }, {
            default: _withCtx(() => [
              _createVNode(_component_v_row, {
                "no-gutters": "",
                class: "d-flex justify-end align-center"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_tooltip, {
                    location: "bottom",
                    text: "Lier un document"
                  }, {
                    activator: _withCtx(({ props }) => [
                      _createVNode(_component_v_btn, _mergeProps({
                        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.dialogAuditCheckDocumentsManager = true))
                      }, props, {
                        size: "x-small",
                        icon: "$oss-upload",
                        class: "mx-1"
                      }), null, 16)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_tooltip, { location: "bottom" }, {
                    activator: _withCtx(({ props }) => [
                      _createVNode(_component_v_btn, _mergeProps({
                        onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.openChat = !_ctx.openChat))
                      }, props, {
                        class: "btn",
                        size: "x-small",
                        icon: "$oss-chat"
                      }), null, 16)
                    ]),
                    default: _withCtx(() => [
                      _cache[29] || (_cache[29] = _createElementVNode("span", null, "Message", -1))
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_btn, {
                    disabled: 
                            _ctx.closedPeriod ||
                            _ctx.validated ||
                            _ctx.loading ||
                            _ctx.dataLoading ||
                            !_ctx.acKey ||
                            !_ctx.accountingPeriod
                        ,
                    onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.createGrossSalaryMatchData())),
                    size: "small",
                    class: "mx-1"
                  }, {
                    default: _withCtx(() => _cache[30] || (_cache[30] = [
                      _createTextVNode(" Enregistrer ")
                    ])),
                    _: 1
                  }, 8, ["disabled"]),
                  _createVNode(_component_v_btn, {
                    disabled: 
                            _ctx.disabledBtnGlobalValidation ||
                            _ctx.loading ||
                            _ctx.dataLoading ||
                            !_ctx.acKey ||
                            !_ctx.accountingPeriod
                        ,
                    onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.validateFunction())),
                    size: "small",
                    class: "mx-1"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.validated ? "Invalider" : "Valider"), 1)
                    ]),
                    _: 1
                  }, 8, ["disabled"]),
                  (_ctx.isEnableReview)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        _cache[31] || (_cache[31] = _createElementVNode("div", { style: {"border-right":"2px solid black","width":"2px","height":"25px","margin":"0 4px"} }, null, -1)),
                        _createVNode(_component_v_icon, {
                          disabled: 
                                _ctx.reviewed === 1 ||
                                !_ctx.isEnableReview ||
                                !_ctx.validated ||
                                _ctx.loading ||
                                _ctx.dataLoading ||
                                !_ctx.acKey
                            ,
                          size: "small",
                          icon: "$fa-thumbs-up",
                          color: "primary",
                          class: "mx-1",
                          onClick: _cache[5] || (_cache[5] = ($event: any) => {
                                _ctx.reviewed = 1;
                                _ctx.createGrossSalaryMatchData('REVIEW');
                            })
                        }, null, 8, ["disabled"]),
                        _createVNode(_component_v_icon, {
                          disabled: 
                                _ctx.reviewed === -1 ||
                                !_ctx.isEnableReview ||
                                !_ctx.validated ||
                                _ctx.loading ||
                                _ctx.dataLoading ||
                                !_ctx.acKey
                            ,
                          size: "small",
                          icon: "$fa-thumbs-down",
                          color: "primary",
                          class: "mx-1",
                          onClick: _cache[6] || (_cache[6] = ($event: any) => {
                                _ctx.reviewed = -1;
                                _ctx.createGrossSalaryMatchData('REVIEW');
                            })
                        }, null, 8, ["disabled"]),
                        _cache[32] || (_cache[32] = _createElementVNode("div", { style: {"border-right":"2px solid black","width":"1px","height":"25px","margin":"0 4px"} }, null, -1))
                      ], 64))
                    : _createCommentVNode("", true),
                  _createVNode(_component_v_tooltip, { location: "bottom" }, {
                    activator: _withCtx(({ props }) => [
                      _createVNode(_component_v_btn_prev, _mergeProps(props, {
                        disabled: !_ctx.previousControl,
                        onClick: _cache[7] || (_cache[7] = ($event: any) => {
                                    _ctx.reviewed = 0;
                                    _ctx.openChat = false;
                                    _ctx.goToPreviousControl();
                                })
                      }), null, 16, ["disabled"])
                    ]),
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_1, " Contrôle précédent : " + _toDisplayString(_ctx.previousControl && _ctx.previousControl.title
                                    ? _ctx.previousControl.title
                                    : ""), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_tooltip, { location: "bottom" }, {
                    activator: _withCtx(({ props }) => [
                      _createVNode(_component_v_btn_next, _mergeProps(props, {
                        onClick: _cache[8] || (_cache[8] = ($event: any) => {
                                    _ctx.reviewed = 0;
                                    _ctx.openChat = false;
                                    _ctx.goToNextControl();
                                }),
                        disabled: !_ctx.nextControl
                      }), null, 16, ["disabled"])
                    ]),
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_2, " Contrôle suivant : " + _toDisplayString(_ctx.nextControl && _ctx.nextControl.title ? _ctx.nextControl.title : ""), 1)
                    ]),
                    _: 1
                  }),
                  _cache[39] || (_cache[39] = _createElementVNode("div", { style: {"border-right":"2px solid black","width":"1px","height":"25px","margin":"0 4px"} }, null, -1)),
                  _createVNode(_component_v_menu, { "offset-y": "" }, {
                    activator: _withCtx(({ props }) => [
                      _createVNode(_component_v_btn_icon, _mergeProps({ icon: "$dots_vertical" }, props, {
                        class: "mx-1",
                        color: "secondary"
                      }), null, 16)
                    ]),
                    default: _withCtx(() => [
                      _createVNode(_component_v_list, { nav: "" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_list_item, {
                            onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.displayActivityDialog = true))
                          }, {
                            append: _withCtx(() => [
                              _createVNode(_component_v_icon, null, {
                                default: _withCtx(() => _cache[34] || (_cache[34] = [
                                  _createTextVNode("$oss-activity")
                                ])),
                                _: 1
                              })
                            ]),
                            default: _withCtx(() => [
                              _createVNode(_component_v_list_item_title, null, {
                                default: _withCtx(() => _cache[33] || (_cache[33] = [
                                  _createTextVNode("Afficher l'activité")
                                ])),
                                _: 1
                              })
                            ]),
                            _: 1
                          }),
                          (!_ctx.showDeleteAcrBtnIfRecovery)
                            ? (_openBlock(), _createBlock(_component_v_tooltip, {
                                key: 0,
                                location: "bottom"
                              }, {
                                activator: _withCtx(({ props }) => [
                                  _createElementVNode("div", _mergeProps({ "no-gutters": "" }, props), [
                                    _createVNode(_component_v_list_item, {
                                      "no-gutters": "",
                                      disabled: ""
                                    }, {
                                      append: _withCtx(() => [
                                        _createVNode(_component_v_icon, { size: "small" }, {
                                          default: _withCtx(() => _cache[36] || (_cache[36] = [
                                            _createTextVNode(" $oss-trash ")
                                          ])),
                                          _: 1
                                        })
                                      ]),
                                      default: _withCtx(() => [
                                        _createVNode(_component_v_list_item_title, null, {
                                          default: _withCtx(() => _cache[35] || (_cache[35] = [
                                            _createTextVNode(" Supprimer le contrôle ")
                                          ])),
                                          _: 1
                                        })
                                      ]),
                                      _: 1
                                    })
                                  ], 16)
                                ]),
                                default: _withCtx(() => [
                                  _createElementVNode("span", null, _toDisplayString(_ctx.showDeleteAcrBtnTooltipMessage), 1)
                                ]),
                                _: 1
                              }))
                            : (_openBlock(), _createBlock(_component_v_list_item, {
                                key: 1,
                                "no-gutters": "",
                                onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.deleteAuditCheckResultDialog = true))
                              }, {
                                append: _withCtx(() => [
                                  _createVNode(_component_v_icon, null, {
                                    default: _withCtx(() => _cache[38] || (_cache[38] = [
                                      _createTextVNode("$oss-trash")
                                    ])),
                                    _: 1
                                  })
                                ]),
                                default: _withCtx(() => [
                                  _createVNode(_component_v_list_item_title, null, {
                                    default: _withCtx(() => _cache[37] || (_cache[37] = [
                                      _createTextVNode(" Supprimer le contrôle ")
                                    ])),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }))
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createElementVNode("div", _hoisted_3, [
        (_ctx.loading || _ctx.dataLoading)
          ? (_openBlock(), _createBlock(_component_v_card, {
              key: 0,
              elevation: "0",
              style: {"background-color":"#ffffff","border-radius":"25px","margin-top":"10px"}
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_card_title, { class: "pa-4 d-flex justify-center" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_progress_circular, {
                      indeterminate: "",
                      class: "mr-3"
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }))
          : (!_ctx.accountingPeriod)
            ? (_openBlock(), _createBlock(_component_v_row, {
                key: 1,
                "no-gutters": "",
                class: "d-flex flex-column justify-center align-center mb-3"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_icon, {
                    class: "mr-2 mb-1",
                    size: "large"
                  }, {
                    default: _withCtx(() => _cache[40] || (_cache[40] = [
                      _createTextVNode(" $oss-warning ")
                    ])),
                    _: 1
                  }),
                  _cache[41] || (_cache[41] = _createElementVNode("h3", null, "Aucune période sélectionnée", -1))
                ]),
                _: 1
              }))
            : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                (_ctx.closedPeriod)
                  ? (_openBlock(), _createBlock(_component_v_row, {
                      key: 0,
                      "no-gutters": "",
                      class: "d-flex flex-column justify-center align-center mb-3"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_icon, {
                          class: "mr-2 mb-1",
                          size: "large"
                        }, {
                          default: _withCtx(() => _cache[42] || (_cache[42] = [
                            _createTextVNode(" $oss-warning ")
                          ])),
                          _: 1
                        }),
                        _cache[43] || (_cache[43] = _createElementVNode("h3", null, "Période clôturée", -1))
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                (_ctx.noResults)
                  ? (_openBlock(), _createBlock(_component_v_row, {
                      key: 1,
                      "no-gutters": ""
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_col, {
                          cols: "12",
                          class: "d-flex justify-center"
                        }, {
                          default: _withCtx(() => _cache[44] || (_cache[44] = [
                            _createElementVNode("h3", null, "Aucune écriture enregistrée sur l'exercice fiscal sélectionné", -1)
                          ])),
                          _: 1
                        })
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.accountableAccounts, (accountableAccount, i) => {
                  return _withDirectives((_openBlock(), _createBlock(_component_v_card, {
                    key: i,
                    style: {"background-color":"white","border-radius":"25px"},
                    class: "my-2 pa-4",
                    elevation: "0"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_row, {
                        "no-gutters": "",
                        class: "d-flex align-center"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_col, { cols: "4" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_row, {
                                "no-gutters": "",
                                class: "d-flex align-center"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_col, null, {
                                    default: _withCtx(() => [
                                      (accountableAccount.name)
                                        ? (_openBlock(), _createElementBlock("h3", _hoisted_4, _toDisplayString(accountableAccount.name), 1))
                                        : _createCommentVNode("", true)
                                    ]),
                                    _: 2
                                  }, 1024)
                                ]),
                                _: 2
                              }, 1024),
                              _createVNode(_component_v_row, {
                                "no-gutters": "",
                                class: "d-flex align-center"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_col, null, {
                                    default: _withCtx(() => [
                                      (accountableAccount.description)
                                        ? (_openBlock(), _createElementBlock("h3", _hoisted_5, _toDisplayString(accountableAccount.description), 1))
                                        : _createCommentVNode("", true)
                                    ]),
                                    _: 2
                                  }, 1024)
                                ]),
                                _: 2
                              }, 1024)
                            ]),
                            _: 2
                          }, 1024),
                          _createVNode(_component_v_col, {
                            cols: "2",
                            class: "pr-10"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_row, {
                                "no-gutters": "",
                                class: "d-flex align-center"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_col, { class: "d-flex justify-end" }, {
                                    default: _withCtx(() => _cache[45] || (_cache[45] = [
                                      _createElementVNode("h3", { class: "pl-4" }, "Solde comptable", -1)
                                    ])),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_v_row, {
                                "no-gutters": "",
                                class: "d-flex align-center"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_col, { class: "d-flex justify-end" }, {
                                    default: _withCtx(() => [
                                      (accountableAccount.totalBalance)
                                        ? (_openBlock(), _createElementBlock("h3", _hoisted_6, _toDisplayString(_ctx.newCommonFormatCurrency(
                                                accountableAccount.totalBalance,
                                                { currency: "", DC: true },
                                            )), 1))
                                        : (_openBlock(), _createElementBlock("h3", _hoisted_7, "- €"))
                                    ]),
                                    _: 2
                                  }, 1024)
                                ]),
                                _: 2
                              }, 1024)
                            ]),
                            _: 2
                          }, 1024),
                          _createVNode(_component_v_col, {
                            cols: "3",
                            class: "pr-10"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_row, {
                                "no-gutters": "",
                                class: "d-flex align-center"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_col, { class: "d-flex justify-end" }, {
                                    default: _withCtx(() => _cache[46] || (_cache[46] = [
                                      _createElementVNode("h3", null, "Vérification extra-comptable", -1)
                                    ])),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_v_row, {
                                "no-gutters": "",
                                class: "d-flex align-center"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_col, { class: "d-flex justify-end" }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_oss_text_field_filled, {
                                        modelValue: accountableAccount.manualAmount,
                                        "onUpdate:modelValue": [($event: any) => ((accountableAccount.manualAmount) = $event), ($event: any) => (_ctx.changeGap(i))],
                                        class: "d-flex justify-end",
                                        autofocus: "",
                                        hideDetails: ""
                                      }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                    ]),
                                    _: 2
                                  }, 1024)
                                ]),
                                _: 2
                              }, 1024)
                            ]),
                            _: 2
                          }, 1024),
                          _createVNode(_component_v_col, {
                            cols: "2",
                            class: "pr-10"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_row, {
                                "no-gutters": "",
                                class: "d-flex align-center"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_col, { class: "d-flex justify-end" }, {
                                    default: _withCtx(() => _cache[47] || (_cache[47] = [
                                      _createElementVNode("h3", { class: "pl-4" }, "Écart", -1)
                                    ])),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_v_row, {
                                "no-gutters": "",
                                class: "d-flex align-center"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_col, { class: "d-flex justify-end" }, {
                                    default: _withCtx(() => [
                                      (
                                            accountableAccount.gap > 2 ||
                                            accountableAccount.gap < -2
                                        )
                                        ? (_openBlock(), _createElementBlock("h3", _hoisted_8, _toDisplayString(_ctx.newCommonFormatCurrency(accountableAccount.gap, {
                                                currency: "",
                                                DC: true,
                                            })), 1))
                                        : (_openBlock(), _createElementBlock("h3", _hoisted_9, _toDisplayString(_ctx.newCommonFormatCurrency(accountableAccount.gap, {
                                                currency: "",
                                                DC: true,
                                            })), 1))
                                    ]),
                                    _: 2
                                  }, 1024)
                                ]),
                                _: 2
                              }, 1024)
                            ]),
                            _: 2
                          }, 1024),
                          _createVNode(_component_v_col, { cols: "1" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_row, {
                                "no-gutters": "",
                                class: "d-flex align-center"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_col, { cols: "6" }, {
                                    default: _withCtx(() => [
                                      (accountableAccount.validated)
                                        ? (_openBlock(), _createBlock(_component_v_icon, {
                                            key: 0,
                                            class: "text-primary",
                                            icon: "$check_circle"
                                          }))
                                        : _createCommentVNode("", true)
                                    ]),
                                    _: 2
                                  }, 1024),
                                  _createVNode(_component_v_col, { cols: "6" }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_v_btn_icon, {
                                        icon: 
                                            accountableAccount.expand
                                                ? '$fa-chevron-up'
                                                : '$fa-chevron-down'
                                        ,
                                        onClick: ($event: any) => (_ctx.aaExpand(accountableAccount)),
                                        style: {"width":"40px"},
                                        class: "d-inline px-2"
                                      }, null, 8, ["icon", "onClick"])
                                    ]),
                                    _: 2
                                  }, 1024)
                                ]),
                                _: 2
                              }, 1024)
                            ]),
                            _: 2
                          }, 1024)
                        ]),
                        _: 2
                      }, 1024),
                      _withDirectives(_createVNode(_component_v_card_text, { transition: "expand" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_row, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_col, { cols: "12" }, {
                                default: _withCtx(() => [
                                  _withDirectives(_createVNode(_component_AccountableAccountBalanceDetail, {
                                    companyId: _ctx.companyId,
                                    accountingPeriodId: _ctx.accountingPeriodId,
                                    accountableAccountInfo: 
                                        accountableAccount.accountableAccountInfo
                                    ,
                                    userId: _ctx.currentUser.id,
                                    notReconciliated: _ctx.withoutLettering,
                                    withoutBank: _ctx.withoutBank,
                                    withoutDocument: _ctx.withoutDocument,
                                    inAccountingTransactions: _ctx.accountingTransactions,
                                    onQueryDone: _ctx.fetchTotals
                                  }, null, 8, ["companyId", "accountingPeriodId", "accountableAccountInfo", "userId", "notReconciliated", "withoutBank", "withoutDocument", "inAccountingTransactions", "onQueryDone"]), [
                                    [_vShow, 
                                        accountableAccount.queryLength &&
                                        accountableAccount.queryLength > 0
                                    ]
                                  ])
                                ]),
                                _: 2
                              }, 1024)
                            ]),
                            _: 2
                          }, 1024),
                          _createVNode(_component_v_row, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_col, { style: {"padding-bottom":"0"} }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_card_title, { style: {"padding-top":"20px","padding-bottom":"0","padding-left":"0"} }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_v_row, { "no-gutters": "" }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_v_col, { cols: "6" }, {
                                            default: _withCtx(() => _cache[48] || (_cache[48] = [
                                              _createElementVNode("h5", null, "Commentaires", -1)
                                            ])),
                                            _: 1
                                          }),
                                          _createVNode(_component_v_col, {
                                            cols: "6",
                                            class: "d-flex justify-end"
                                          }, {
                                            default: _withCtx(() => [
                                              (
                                                    accountableAccount.gap <= 2 &&
                                                    accountableAccount.gap >= -2 &&
                                                    accountableAccount.gap !== 0 &&
                                                    _ctx.accountingPeriod &&
                                                    !_ctx.accountingPeriod.closed
                                                )
                                                ? (_openBlock(), _createBlock(_component_v_btn, {
                                                    key: 0,
                                                    onClick: _withModifiers(($event: any) => {
                                                    _ctx.miscellaneousOperationDialog = true;
                                                    _ctx.createRows(accountableAccount);
                                                }, ["stop"]),
                                                    size: "small",
                                                    class: "px-2 mx-1"
                                                  }, {
                                                    default: _withCtx(() => [
                                                      _cache[50] || (_cache[50] = _createTextVNode(" Solder ")),
                                                      _createVNode(_component_v_icon, null, {
                                                        default: _withCtx(() => _cache[49] || (_cache[49] = [
                                                          _createTextVNode("$not_equal")
                                                        ])),
                                                        _: 1
                                                      })
                                                    ]),
                                                    _: 2
                                                  }, 1032, ["onClick"]))
                                                : (_openBlock(), _createBlock(_component_v_btn, {
                                                    key: 1,
                                                    disabled: "",
                                                    size: "small",
                                                    class: "px-2 mx-1"
                                                  }, {
                                                    default: _withCtx(() => [
                                                      _cache[52] || (_cache[52] = _createTextVNode(" Solder ")),
                                                      _createVNode(_component_v_icon, null, {
                                                        default: _withCtx(() => _cache[51] || (_cache[51] = [
                                                          _createTextVNode("$not_equal")
                                                        ])),
                                                        _: 1
                                                      })
                                                    ]),
                                                    _: 1
                                                  })),
                                              (
                                                    accountableAccount.gap === 0 ||
                                                    _ctx.closedPeriod ||
                                                    accountableAccount.validated
                                                )
                                                ? (_openBlock(), _createBlock(_component_v_btn, {
                                                    key: 2,
                                                    disabled: "",
                                                    size: "small",
                                                    class: "px-2 mx-1"
                                                  }, {
                                                    default: _withCtx(() => _cache[53] || (_cache[53] = [
                                                      _createTextVNode(" OD ")
                                                    ])),
                                                    _: 1
                                                  }))
                                                : (_openBlock(), _createBlock(_component_v_btn, {
                                                    key: 3,
                                                    onClick: ($event: any) => {
                                                    _ctx.miscellaneousOperationDialog = true;
                                                    _ctx.createRows(accountableAccount);
                                                },
                                                    size: "small",
                                                    class: "px-2 mx-1"
                                                  }, {
                                                    default: _withCtx(() => _cache[54] || (_cache[54] = [
                                                      _createTextVNode(" OD ")
                                                    ])),
                                                    _: 2
                                                  }, 1032, ["onClick"])),
                                              (_ctx.closedPeriod || accountableAccount.validated)
                                                ? (_openBlock(), _createBlock(_component_v_btn, {
                                                    key: 4,
                                                    disabled: "",
                                                    size: "small",
                                                    class: "px-2 mx-1"
                                                  }, {
                                                    default: _withCtx(() => _cache[55] || (_cache[55] = [
                                                      _createTextVNode(" Enregistrer ")
                                                    ])),
                                                    _: 1
                                                  }))
                                                : (
                                                    accountableAccount.manualAmount ||
                                                    accountableAccount.comment
                                                )
                                                  ? (_openBlock(), _createBlock(_component_v_btn, {
                                                      key: 5,
                                                      onClick: _cache[11] || (_cache[11] = _withModifiers(($event: any) => (_ctx.createGrossSalaryMatchData()), ["stop"])),
                                                      size: "small",
                                                      class: "px-2 mx-1"
                                                    }, {
                                                      default: _withCtx(() => _cache[56] || (_cache[56] = [
                                                        _createTextVNode(" Enregistrer ")
                                                      ])),
                                                      _: 1
                                                    }))
                                                  : (_openBlock(), _createBlock(_component_v_btn, {
                                                      key: 6,
                                                      disabled: "",
                                                      size: "small",
                                                      class: "px-2 mx-1"
                                                    }, {
                                                      default: _withCtx(() => _cache[57] || (_cache[57] = [
                                                        _createTextVNode(" Enregistrer ")
                                                      ])),
                                                      _: 1
                                                    })),
                                              (
                                                    !accountableAccount.validated &&
                                                    accountableAccount.manualAmount &&
                                                    accountableAccount.gap <= 2 &&
                                                    accountableAccount.gap >= -2
                                                )
                                                ? (_openBlock(), _createBlock(_component_v_btn, {
                                                    key: 7,
                                                    onClick: ($event: any) => {
                                                    accountableAccount.validated =
                                                        !accountableAccount.validated;
                                                    accountableAccount.expand = false;
                                                    _ctx.createGrossSalaryMatchData('VALIDATE');
                                                },
                                                    size: "small",
                                                    class: "px-2 ml-1"
                                                  }, {
                                                    default: _withCtx(() => _cache[58] || (_cache[58] = [
                                                      _createTextVNode(" Valider ")
                                                    ])),
                                                    _: 2
                                                  }, 1032, ["onClick"]))
                                                : (!accountableAccount.validated)
                                                  ? (_openBlock(), _createBlock(_component_v_btn, {
                                                      key: 8,
                                                      disabled: "",
                                                      size: "small",
                                                      class: "px-2 ml-1"
                                                    }, {
                                                      default: _withCtx(() => _cache[59] || (_cache[59] = [
                                                        _createTextVNode(" Valider ")
                                                      ])),
                                                      _: 1
                                                    }))
                                                  : (_openBlock(), _createBlock(_component_v_btn, {
                                                      key: 9,
                                                      onClick: ($event: any) => {
                                                    accountableAccount.validated =
                                                        !accountableAccount.validated;
                                                    _ctx.createGrossSalaryMatchData('UPDATE');
                                                },
                                                      size: "small",
                                                      class: "px-2 ml-1"
                                                    }, {
                                                      default: _withCtx(() => _cache[60] || (_cache[60] = [
                                                        _createTextVNode(" Invalider ")
                                                      ])),
                                                      _: 2
                                                    }, 1032, ["onClick"]))
                                            ]),
                                            _: 2
                                          }, 1024)
                                        ]),
                                        _: 2
                                      }, 1024)
                                    ]),
                                    _: 2
                                  }, 1024)
                                ]),
                                _: 2
                              }, 1024)
                            ]),
                            _: 2
                          }, 1024),
                          _createVNode(_component_v_row, { class: "pt-6" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_col, { style: {"padding-top":"0"} }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_card_text, { style: {"padding":"0"} }, {
                                    default: _withCtx(() => [
                                      (_openBlock(), _createBlock(_component_v_textarea, {
                                        modelValue: accountableAccount.comment,
                                        "onUpdate:modelValue": ($event: any) => ((accountableAccount.comment) = $event),
                                        disabled: _ctx.closedPeriod || _ctx.validated,
                                        "auto-grow": "",
                                        style: {"height":"auto","border":"1px #ededed solid"},
                                        outlined: "",
                                        key: i
                                      }, null, 8, ["modelValue", "onUpdate:modelValue", "disabled"]))
                                    ]),
                                    _: 2
                                  }, 1024)
                                ]),
                                _: 2
                              }, 1024)
                            ]),
                            _: 2
                          }, 1024)
                        ]),
                        _: 2
                      }, 1536), [
                        [_vShow, accountableAccount.expand]
                      ])
                    ]),
                    _: 2
                  }, 1024)), [
                    [_vShow, accountableAccount.queryLength > 0]
                  ])
                }), 128)),
                (!_ctx.loading && !_ctx.dataLoading)
                  ? (_openBlock(), _createBlock(_component_AuditConnectedAcrDocuments, {
                      key: 2,
                      connectedDocuments: _ctx.connectedDocuments,
                      companyId: _ctx.companyId,
                      acKey: _ctx.acKey,
                      auditCheckResult: _ctx.auditCheckResult || {},
                      accountingPeriodId: _ctx.accountingPeriodId || undefined,
                      onUnlinkedDocument: _cache[12] || (_cache[12] = ($event: any) => (_ctx.unlinkDocument($event))),
                      onShowLinkedDocument: _cache[13] || (_cache[13] = ($event: any) => (_ctx.showLinkedDocument($event)))
                    }, null, 8, ["connectedDocuments", "companyId", "acKey", "auditCheckResult", "accountingPeriodId"]))
                  : _createCommentVNode("", true),
                (!_ctx.loading && !_ctx.dataLoading)
                  ? (_openBlock(), _createBlock(_component_AuditConnectedAcrResults, {
                      key: 3,
                      results: _ctx.results,
                      companyId: _ctx.companyId
                    }, null, 8, ["results", "companyId"]))
                  : _createCommentVNode("", true),
                _createVNode(_component_v_card, {
                  elevation: "0",
                  style: {"background-color":"white","border-radius":"25px"},
                  class: "my-2 pa-4"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_row, {
                      "no-gutters": "",
                      class: "d-flex align-center"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_col, { cols: "11" }, {
                          default: _withCtx(() => _cache[61] || (_cache[61] = [
                            _createElementVNode("h3", { class: "pl-4" }, "Commentaires détaillés", -1)
                          ])),
                          _: 1
                        }),
                        _createVNode(_component_v_spacer),
                        _createVNode(_component_v_col, {
                          cols: "1",
                          class: "d-flex align-center px-0 justify-center"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_row, null, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_col, {
                                  cols: "6",
                                  class: "align-center pa-0"
                                }),
                                _createVNode(_component_v_col, {
                                  cols: "6",
                                  class: "align-center pa-0"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_btn_icon, {
                                      icon: 
                                            _ctx.commentExpand ? '$fa-chevron-up' : '$fa-chevron-down'
                                        ,
                                      onClick: _cache[14] || (_cache[14] = ($event: any) => (_ctx.commentExpand = !_ctx.commentExpand)),
                                      style: {"width":"40px"},
                                      class: "d-inline px-2"
                                    }, null, 8, ["icon"])
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    (_ctx.commentExpand)
                      ? (_openBlock(), _createBlock(_component_v_card_text, {
                          key: 0,
                          transition: "expand"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_row, { class: "pt-6" }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_col, { style: {"padding-top":"0"} }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_card_text, { style: {"padding":"0"} }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_v_textarea, {
                                          modelValue: _ctx.longComment,
                                          "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.longComment) = $event)),
                                          disabled: _ctx.closedPeriod || _ctx.validated,
                                          "auto-grow": "",
                                          style: {"height":"auto","border":"1px #ededed solid"},
                                          outlined: ""
                                        }, null, 8, ["modelValue", "disabled"])
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_v_row, null, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_col, { style: {"padding-bottom":"0"} }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_card_title, { style: {"padding-top":"20px","padding-bottom":"0","padding-left":"0"} }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_v_spacer),
                                        (_ctx.closedPeriod || _ctx.validated)
                                          ? (_openBlock(), _createBlock(_component_v_btn, {
                                              key: 0,
                                              disabled: "",
                                              rounded: "",
                                              class: "btn btn_blue",
                                              size: "small"
                                            }, {
                                              default: _withCtx(() => _cache[62] || (_cache[62] = [
                                                _createTextVNode(" Enregistrer ")
                                              ])),
                                              _: 1
                                            }))
                                          : (_openBlock(), _createBlock(_component_v_btn, {
                                              key: 1,
                                              rounded: "",
                                              class: "btn btn_blue",
                                              onClick: _cache[16] || (_cache[16] = _withModifiers(($event: any) => (_ctx.createGrossSalaryMatchData()), ["stop"])),
                                              size: "small"
                                            }, {
                                              default: _withCtx(() => _cache[63] || (_cache[63] = [
                                                _createTextVNode(" Enregistrer ")
                                              ])),
                                              _: 1
                                            }))
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_card, {
                  elevation: "0",
                  style: {"background-color":"white","border-radius":"25px"},
                  class: "my-2 pa-4"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_row, {
                      "no-gutters": "",
                      class: "d-flex align-center"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_col, { cols: "11" }, {
                          default: _withCtx(() => _cache[64] || (_cache[64] = [
                            _createElementVNode("h3", { class: "pl-4" }, "Commentaires synthétiques", -1)
                          ])),
                          _: 1
                        }),
                        _createVNode(_component_v_spacer),
                        _createVNode(_component_v_col, {
                          cols: "1",
                          class: "d-flex align-center px-0 justify-center"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_row, null, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_col, {
                                  cols: "6",
                                  class: "align-center pa-0"
                                }),
                                _createVNode(_component_v_col, {
                                  cols: "6",
                                  class: "align-center pa-0"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_btn_icon, {
                                      icon: 
                                            _ctx.shortCommentExpand
                                                ? '$fa-chevron-up'
                                                : '$fa-chevron-down'
                                        ,
                                      onClick: _cache[17] || (_cache[17] = ($event: any) => (_ctx.shortCommentExpand = !_ctx.shortCommentExpand)),
                                      style: {"width":"40px"},
                                      class: "d-inline px-2"
                                    }, null, 8, ["icon"])
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    (_ctx.shortCommentExpand)
                      ? (_openBlock(), _createBlock(_component_v_card_text, {
                          key: 0,
                          transition: "expand"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_row, { class: "pt-6" }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_col, { style: {"padding-top":"0"} }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_card_text, { style: {"padding":"0"} }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_v_textarea, {
                                          modelValue: _ctx.shortComment,
                                          "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.shortComment) = $event)),
                                          disabled: _ctx.closedPeriod || _ctx.validated,
                                          "auto-grow": "",
                                          style: {"height":"auto","border":"1px #ededed solid"},
                                          outlined: ""
                                        }, null, 8, ["modelValue", "disabled"])
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_v_row, null, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_col, { style: {"padding-bottom":"0"} }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_card_title, { style: {"padding-top":"20px","padding-bottom":"0","padding-left":"0"} }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_v_spacer),
                                        (_ctx.closedPeriod || _ctx.validated)
                                          ? (_openBlock(), _createBlock(_component_v_btn, {
                                              key: 0,
                                              disabled: "",
                                              rounded: "",
                                              class: "btn btn_blue",
                                              size: "small"
                                            }, {
                                              default: _withCtx(() => _cache[65] || (_cache[65] = [
                                                _createTextVNode(" Enregistrer ")
                                              ])),
                                              _: 1
                                            }))
                                          : (_openBlock(), _createBlock(_component_v_btn, {
                                              key: 1,
                                              rounded: "",
                                              class: "btn btn_blue",
                                              onClick: _cache[19] || (_cache[19] = _withModifiers(($event: any) => (_ctx.createGrossSalaryMatchData()), ["stop"])),
                                              size: "small"
                                            }, {
                                              default: _withCtx(() => _cache[66] || (_cache[66] = [
                                                _createTextVNode(" Enregistrer ")
                                              ])),
                                              _: 1
                                            }))
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                }),
                (_ctx.displayActivityDialog)
                  ? (_openBlock(), _createBlock(_component_oss_dialog, {
                      key: 4,
                      modelValue: _ctx.displayActivityDialog,
                      "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.displayActivityDialog) = $event)),
                      title: "Activité",
                      "valid-title": "Fermer",
                      onValid: _cache[21] || (_cache[21] = ($event: any) => (_ctx.displayActivityDialog = false)),
                      onClose: _cache[22] || (_cache[22] = ($event: any) => (_ctx.displayActivityDialog = false)),
                      "min-width": "60vw"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_UsersActivitiesHistory, {
                          auditCheckKey: _ctx.acKey,
                          accountingPeriodId: _ctx.accountingPeriodId
                        }, null, 8, ["auditCheckKey", "accountingPeriodId"])
                      ]),
                      _: 1
                    }, 8, ["modelValue"]))
                  : _createCommentVNode("", true),
                (_ctx.deleteAuditCheckResultDialog)
                  ? (_openBlock(), _createBlock(_component_AuditDeleteAuditCheckResultDialog, {
                      key: 5,
                      modelValue: _ctx.deleteAuditCheckResultDialog,
                      "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((_ctx.deleteAuditCheckResultDialog) = $event)),
                      auditCheckResultId: _ctx.auditCheckResultId,
                      onClosed: _cache[24] || (_cache[24] = ($event: any) => {
                            _ctx.deleteAuditCheckResultLoading = false;
                            _ctx.deleteAuditCheckResultDialog = false;
                        }),
                      onDeletedAcr: _ctx.deleteAcrDone
                    }, null, 8, ["modelValue", "auditCheckResultId", "onDeletedAcr"]))
                  : _createCommentVNode("", true),
                _createVNode(_component_oss_dialog, {
                  modelValue: _ctx.miscellaneousOperationDialog,
                  "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => ((_ctx.miscellaneousOperationDialog) = $event)),
                  actions: _ctx.actionsMiscellaneousOperation,
                  "min-width": "90vw"
                }, {
                  default: _withCtx(() => [
                    (_ctx.miscellaneousOperationDialog)
                      ? (_openBlock(), _createBlock(_component_AccountingItemEdition2, {
                          key: 0,
                          companyId: _ctx.companyId,
                          prefilledRows: _ctx.miscellanousOperationData,
                          acKey: _ctx.acKey,
                          auditCheckResult: _ctx.auditCheckResult,
                          accountingPeriodId: _ctx.accountingPeriodId,
                          onUpsert: _cache[25] || (_cache[25] = ($event: any) => (_ctx.refresh())),
                          actions: _ctx.actionsMiscellaneousOperation
                        }, null, 8, ["companyId", "prefilledRows", "acKey", "auditCheckResult", "accountingPeriodId", "actions"]))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                }, 8, ["modelValue", "actions"]),
                (_ctx.openChat)
                  ? (_openBlock(), _createBlock(_component_Chat, {
                      key: 6,
                      auditCheckAccountingPeriodKey: _ctx.chatId,
                      chatTitle: 'Chat'
                    }, null, 8, ["auditCheckAccountingPeriodKey"]))
                  : _createCommentVNode("", true),
                (_ctx.dialogAuditCheckDocumentsManager)
                  ? (_openBlock(), _createBlock(_component_AuditCheckDocumentsManager, {
                      key: 7,
                      modelValue: _ctx.dialogAuditCheckDocumentsManager,
                      "onUpdate:modelValue": _cache[27] || (_cache[27] = ($event: any) => ((_ctx.dialogAuditCheckDocumentsManager) = $event)),
                      disabled: _ctx.loading || _ctx.dataLoading || !_ctx.acKey || !_ctx.accountingPeriod,
                      companyId: _ctx.companyId,
                      documentToDisplay: _ctx.documentToDisplay,
                      connectedDocuments: _ctx.connectedDocuments || [],
                      acKey: _ctx.acKey,
                      auditCheckResult: _ctx.auditCheckResult || {},
                      accountingPeriodId: _ctx.accountingPeriodId || undefined,
                      alreadyLinkedDoc: _ctx.alreadyLinkedDoc,
                      onUpsertedAuditCheckResult: _ctx.upsertedACR,
                      onResetDialogData: _cache[28] || (_cache[28] = ($event: any) => {
                        _ctx.alreadyLinkedDoc = false;
                        _ctx.documentToDisplay = {};
                    })
                    }, null, 8, ["modelValue", "disabled", "companyId", "documentToDisplay", "connectedDocuments", "acKey", "auditCheckResult", "accountingPeriodId", "alreadyLinkedDoc", "onUpsertedAuditCheckResult"]))
                  : _createCommentVNode("", true)
              ], 64))
      ])
    ]),
    _: 1
  }))
}